import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { FaCashRegister, FaEye, FaFilePdf, FaFolderOpen, FaPlus, FaTimes } from 'react-icons/fa';
import Modal from '../../../components/Modal';
import { formatDate, formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import DataTable from "react-data-table-component";
import Receipt from '../../../components/reciept';
import PaymentVoucher from '../../../components/PaymentVoucher';
import ReactToPrint from 'react-to-print';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import FormGenerator from '../../../components/formGenerator';
import { BiTransfer } from "react-icons/bi";
import { toast } from 'react-toastify';

const CashbookPage = () => {
  const [cashbooks, setCashbooks] = useState([]);
  const [filteredCashbooks, setFilteredCashbooks] = useState([]);
  const [selectedCashbook, setSelectedCashbook] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    fromCash: '',
    toCash: '',
    amount: '',
    description: '',
  });
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    bank: '',
    search: '',
  });

  const [showSlidingDiv, setShowSlidingDiv] = useState(false);
  const [output, setOutput] = useState('');
  const [title, setTitle] = useState('');

  const auth = useAuth();
  const allData = useOutletContext();
  const componentRef = useRef(null);

function handleExportToPDF() {
  const input = componentRef.current;
  html2canvas(input).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${title}.pdf`);
  });
}

  // Fetch cashbooks data
  useEffect(() => {
    axios
      .get(rootUrl(`/getCash/${auth.user.cid}`))
      .then((response) => {
        setCashbooks(response.data.data);
        setFilteredCashbooks(response.data.data);
      })
      .catch((error) => console.error('Error fetching cashbooks:', error));
  }, [auth.user.cid]);

  // Filter cashbooks
  useEffect(() => {
    let filtered = cashbooks;

    if (filters.startDate) {
      filtered = filtered.filter((row) => new Date(row.date) >= new Date(filters.startDate));
    }
    if (filters.endDate) {
      filtered = filtered.filter((row) => new Date(row.date) <= new Date(filters.endDate));
    }
    if (filters.bank) {
      filtered = filtered.filter((row) => row.bank === filters.bank);
    }
    if (filters.search) {
      filtered = filtered.filter(
        (row) =>
          row.description?.toLowerCase().includes(filters.search.toLowerCase()) ||
          allData?.coa?.find((a) => a.id === row.coa_id)?.account?.toLowerCase().includes(filters.search.toLowerCase())
      );
    }

    setFilteredCashbooks(filtered);
  }, [filters, cashbooks, allData]);

  const openSlidingDiv = () => {
    setShowSlidingDiv(true);
  };

  const closeSlidingDiv = () => {
    setShowSlidingDiv(false);
  };


  const calculateBalance = () => {
    let balance = 0;
    return filteredCashbooks.map((row) => {
      balance += row.type === 'income' ? parseFloat(row.amount) : - parseFloat(row.amount);
      return { ...row, balance };
    });
  };

  const display = (obj) => {
    openSlidingDiv();
    if (obj.type === 'income') {
      setTitle("Receipt");
      setOutput(<Receipt data={obj} ref={componentRef} />);
    } else {
      setTitle("Payment Voucher");
      setOutput(<PaymentVoucher data={obj} ref={componentRef} />);
    }
  };

  const columns = [
    {
      name: 'Sn',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '50px',
    },
    {
      name: 'Date',
      selector: (row) => formatDate(row.date.substring(0, 10)),
      sortable: true,
    },
    {
      name: 'Chart of Account',
      selector: (row) =>
        allData?.budget?.find((a) => a.id === row.coa_id)?.coa || 'N/A',
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description || 'N/A',
      sortable: true,
    },
    {
      name: 'Cheque #',
      selector: (row) => row.cheque || 'N/A',
      sortable: true,
    },
    {
      name: 'Payee',
      selector: (row) => {
        if (row.type === 'income') {
          return (
            allData?.customer?.find((a) => a.id === row.paye)
              ? `${allData.customer.find((a) => a.id === row.paye).firstname} ${allData.customer.find((a) => a.id === row.paye).lastname}`
              : 'N/A'
          );
        } else {
          return (
            allData?.suppliers?.find((a) => a.id === row.paye)?.name || 'N/A'
          );
        }
      },
      sortable: true,
    },
    {
      name: 'Debit',
      selector: (row) => (row.type === 'income' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    {
      name: 'Credit',
      selector: (row) => (row.type === 'expense' ? formatToZMW(row.amount) : 0),
      sortable: true,
    },
    // {
    //   name: 'Cashbook',
    //   selector: (row) => allData?.bank?.find((a) => a.id === row.bank)?.name || 'N/A',
    //   sortable: true,
    // },
 
    {
      name: 'Balance',
      selector: (row) => formatToZMW(row.balance || 0),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <button
          className="bg-blue-900 hover:bg-blue-900 text-white px-3 py-1 rounded"
          onClick={() => display(row)}
        >
          <FaEye/>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const finalBalance = filteredCashbooks.reduce((total, row) => {
    const amount = parseFloat(row.amount) || 0; 
    return row.type === 'income' ? total + amount : total - amount;
  }, 0);

 async function onsubmit(formdata) {

  formdata['uid'] = auth.user.id

      try{

        const response = await axios.post(rootUrl(`/transfer`), formdata)
        if(response.status === 200){
          toast.success("Added successfully")
          setIsModalVisible(false)
          axios
          .get(rootUrl(`/getCash/${auth.user.cid}`))
          .then((response) => {
            setCashbooks(response.data.data);
            setFilteredCashbooks(response.data.data);
          })
          .catch((error) => console.error('Error fetching cashbooks:', error));
        } 

      }catch(error){
        toast.error(error?.message)
      }

  }

   
       const [fields, setFields] = useState([]);
 
       useEffect(() => {
         if (allData.bank !== undefined) {
           setFields([
          
             {
               type: 'select',
               name: 'fromBank',
               label: 'From',
               required: true,
               options: allData.bank.map(res => ({
                 value: res.id,
                 label: res.name,
               })),
             },
             {
               type: 'select',
               name: 'toBank',
               label: 'To',
               required: true,
               options: allData.bank.map(res => ({
                 value: res.id,
                 label: res.name,
               })),
             },
             { type: 'number', name: 'amount', label: 'Amount', required: true },
             { type: 'textarea', name: 'description', label: 'Description' },
           ]);
         }
       }, [allData]);
       

  return (
    <div className="cashbook-page">
      {/* Cashbook Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="font-bold text-2xl flex items-center">
          <FaCashRegister className="mr-2" /> Cashbook
        </h1>
        <button
          className="border p-2 rounded-lg flex items-center bg-blue-900 text-white"
          onClick={() => setIsModalVisible(true)}
        >
          <BiTransfer  className="mr-2" />  Transfer
        </button>
      </div>

      <hr className="my-2" />

      {/* Filters */}
      <div className="flex gap-4 mb-4">
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.startDate}
          onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
          value={filters.endDate}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <select
          className="border px-3 py-2 rounded"
          value={filters.bank}
          onChange={(e) => setFilters({ ...filters, bank: e.target.value })}
        >
          <option value="">All CashBooks</option>
          {allData?.bank?.map((bank) => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Search..."
          className="border px-3 py-2 rounded"
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />
      </div>

      {/* Data Table */}
      {filteredCashbooks.length > 0 ? (
        <>
          <DataTable
            title=""
            columns={columns}
            data={calculateBalance()}
            pagination
            highlightOnHover
            striped
            responsive
          />
          <div className="text-right font-bold mt-2">
            Final Balance: {formatToZMW(finalBalance)}
          </div>
        </>
      ) : (
        <div className="flex flex-col justify-center items-center">
                                  <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                                  <p className="text-gray-600">No cash records found</p>
                                </div>
      )}


{showSlidingDiv && (
  <div
    id="slidingDiv"
    className="bg-white fixed top-0 right-0 h-full w-3/4 overflow-auto shadow-lg"
  >
    <FaTimes
      onClick={closeSlidingDiv}
      className="p-1 m-1 text-2xl text-red-500 float-right cursor-pointer"
    />

    <h3 className="m-2 font-semibold text-lg">{title}</h3>
    <hr />

    <div className="flex gap-4 p-4">
      {/* <ReactToPrint
        trigger={() => (
          <button className="bg-green-500 text-white px-4 py-2 rounded">
            Print
          </button>
        )}
        content={() => componentRef.current}
      /> */}
      <button
        onClick={handleExportToPDF}
        className="bg-blue-900 text-white px-4 py-2 rounded float-right"
      >
        <FaFilePdf/>
      </button>
    </div>
    <div id="form" ref={componentRef}>
      {output}
    </div>
  </div>
)}


      {/* Modal Placeholder */}
      {isModalVisible && (
        <Modal
          title="New Cashbook Entry"
          onClose={() => setIsModalVisible(false)}
        >
          <FormGenerator fields = {fields} onSubmit={onsubmit} /> 
        </Modal>
      )}
    </div>
  );
};

export default CashbookPage;
